
<div class="neo-copilot-v2" (mousemove)="onMouseMove($event)">
  <div class="landing-view-v2" *ngIf="!hasUserInteracted">
    <div class="landing-container">
      <div class="landing-header">
        <div class="brand-logo">
            <img src="assets/icons-svg/ai-logo-with-name.svg" alt="Copilot" class="copilot-logo-landing">
                  </div>
      </div>

      <div class="hero-section-v2">
        <div class="hero-badge">
          <i class="pi pi-bolt"></i>
          <span>AI-Powered Hiring Assistant</span>
        </div>
        <h1 class="hero-title-v2">Welcome back, {{userName}}</h1>
        <p class="hero-subtitle-v2">
          Streamline your recruitment process with intelligent automation.
          Choose an action below to get started.
        </p>
        </div>
        
      <div class="features-container">
        <div class="features-grid-v2">
          <div class="feature-card-v2" 
               *ngIf="userPrivileges.has('job_role.create')" 
               (click)="selectPurpose('createJob')"
               [style.animation-delay]="'0s'">
            <div class="card-top">
              <div class="feature-icon-v2 job-icon">
                <img src="assets/sideNav-svg/roles.svg" alt="Create Job" class="feature-svg-icon">
              </div>
              <i class="pi pi-arrow-right arrow-icon"></i>
          </div>
            <div class="card-content">
              <h3 class="feature-title-v2">Create Job</h3>
              <p class="feature-description-v2">Set up new job postings with detailed requirements and specifications in minutes.</p>
            </div>
          </div>
          
          <div class="feature-card-v2" 
               *ngIf="userPrivileges.has('event.create')" 
               (click)="selectPurpose('createEvent')"
               [style.animation-delay]="'0.1s'">
            <div class="card-top">
              <div class="feature-icon-v2 event-icon">
                <img src="assets/sideNav-svg/events.svg" alt="Create Event" class="feature-svg-icon">
              </div>
              <i class="pi pi-arrow-right arrow-icon"></i>
          </div>
            <div class="card-content">
              <h3 class="feature-title-v2">Create Event</h3>
              <p class="feature-description-v2">Organize recruitment events, interviews, and training sessions effortlessly.</p>
        </div>
          </div>
          
          <div class="feature-card-v2" 
               *ngIf="userPrivileges.has('job_role.view')" 
               (click)="navigateToJobs()"
               [style.animation-delay]="'0.2s'">
            <div class="card-top">
              <div class="feature-icon-v2 view-jobs-icon">
                <img src="assets/sideNav-svg/roles.svg" alt="View Jobs" class="feature-svg-icon">
              </div>
              <i class="pi pi-arrow-right arrow-icon"></i>
            </div>
            <div class="card-content">
              <h3 class="feature-title-v2">View Jobs</h3>
              <p class="feature-description-v2">Access and manage all your active job postings in one centralized dashboard.</p>
            </div>
          </div>
          
          <div class="feature-card-v2" 
               *ngIf="userPrivileges.has('event.view')" 
               (click)="navigateToEvents()"
               [style.animation-delay]="'0.3s'">
            <div class="card-top">
              <div class="feature-icon-v2 view-events-icon">
                <img src="assets/sideNav-svg/events.svg" alt="View Events" class="feature-svg-icon">
              </div>
              <i class="pi pi-arrow-right arrow-icon"></i>
            </div>
            <div class="card-content">
              <h3 class="feature-title-v2">View Events</h3>
              <p class="feature-description-v2">Track your scheduled events and manage upcoming recruitment activities.</p>
            </div>
          </div>
        </div>
      </div>

      <div class="limited-options-container" *ngIf="showLimitedOptionsMessage">
        <div class="limited-options-message">
          Currently, I can only help with job or event-related requests. Please select one of the available options above.
        </div>
      </div>

      <div class="landing-footer">
        <p class="footer-text">
          <span class="info-icon">ℹ️</span>
          Agent Smith uses AI to assist with hiring tasks. Always review generated content before use.
        </p>
        </div>
      </div>
    </div>

  <div class="chat-interface-v2" *ngIf="hasUserInteracted">
    <div class="chat-layout">
      <div class="chat-main" [class.with-sidebar]="apiResponse">
        <div class="chat-header-v2">
          <button class="back-button" (click)="restartConversation()">
            <i class="pi pi-arrow-left"></i>
            <span>Change Type</span>
          </button>
        </div>

        <div class="chat-messages">
          <div class="messages-container" [class.expanded]="!apiResponse">
            
            <div class="welcome-message" *ngIf="messages.length === 0 && !isLoading && selectedPurpose">
              <img src="assets/sideNav-svg/flash.svg" alt="Copilot" class="welcome-copilot-icon">
              <h2 class="welcome-title">
                {{ selectedPurpose === 'createJob' ? 'Create a new job' : 'Create a new event' }}
              </h2>
              <p class="welcome-description">
                {{ selectedPurpose === 'createJob' ? 
                  'I can help you create a new job posting. Please describe the role including title, requirements, and hiring details.' :
                  'I can help you create a new event. Please describe the event you want to create, including details like type, date, and requirements.' }}
              </p>
              
              <div class="sample-input-card">
                <p class="sample-label">Try this example:</p>
                <button class="sample-button" 
                        [ngClass]="selectedPurpose === 'createJob' ? 'job-sample' : 'event-sample'"
                        (click)="setSampleInput()">
                  <span class="sample-prefix">Sample {{ selectedPurpose === 'createJob' ? 'Job' : 'Event' }}:</span>
                  <span class="sample-text">{{ getSampleText() }}</span>
                </button>
              </div>
            </div>

            <div class="message-list-v2">
              <div class="message-v2" 
                   *ngFor="let message of messages" 
                   [ngClass]="message.type === 'user' ? 'user-message' : 'ai-message'">
                
                <div *ngIf="message.type === 'user'" class="user-message-bubble">
                  <div class="user-message-content" [innerHTML]="message.safeContent || message.content"></div>
                </div>
                
                <div *ngIf="message.type === 'ai'" class="ai-message-wrapper">
                  <img src="assets/copilot.svg" alt="Copilot" class="copilot-logo">
                  <div class="ai-message-bubble">
                    <div class="ai-message-content" [innerHTML]="message.safeContent || message.content"></div>
                  </div>
                </div>
              </div>

              <div class="message-v2 ai-message loading-message" *ngIf="isLoading">
                <div class="ai-message-wrapper">
                  <img src="assets/copilot.svg" alt="Copilot" class="copilot-logo spinning">
                  <div class="ai-message-bubble loading-bubble">
                    <div class="loading-content">
                      <div class="loading-header">
                        <div class="loading-text">
                          <p class="loading-title">Processing your request...</p>
                          <p class="loading-subtitle">{{ getLoadingMessage() }}</p>
                        </div>
                      </div>
                      <div class="progress-section">
                        <div class="progress-bar-container">
                          <div class="progress-bar-fill" [style.width.%]="loadingPercentage"></div>
              </div>
                        <div class="progress-info">
                          <span class="step-text"><strong>Step {{ loadingStep }}</strong> of {{ totalSteps }}</span>
                          <span class="percentage-text">{{ loadingPercentage }}%</span>
            </div>
                  </div>
                    </div>
                </div>
                </div>
              </div>

              <div class="message-v2 ai-message action-message-v2" 
                   *ngIf="apiResponse && !isLoading && !isEditing">
                <div class="ai-message-wrapper">
                  <img src="assets/copilot.svg" alt="Copilot" class="copilot-logo">
                  <div class="ai-message-bubble action-bubble">
                    <div class="action-content">
                      <div class="action-header">
                        <p class="action-text">
                          I've generated the {{ selectedPurpose === 'createJob' ? 'job' : 'event' }} details based on your input. 
                          You can review them in the summary panel.
                        </p>
                      </div>
                    <div class="action-buttons-v2">
                      <button class="btn-secondary" 
                              (click)="selectedPurpose === 'createJob' ? editJobDetails() : editEventDetails()"
                              [disabled]="creationStatus?.type === 'success'">
                        <span>Edit Details</span>
                      </button>
                      <button class="btn-primary" 
                              [class]="selectedPurpose === 'createJob' ? 'job-btn' : 'event-btn'"
                              (click)="selectedPurpose === 'createJob' ? createJobNow() : createEventNow()"
                              [disabled]="isCreating">
                        <span *ngIf="!isCreating">Create {{ selectedPurpose === 'createJob' ? 'Job' : 'Event' }}</span>
                        <span *ngIf="isCreating">Creating...</span>
                      </button>
            </div>

                    <div class="creation-status-v2" 
                         *ngIf="creationStatus" 
                         [ngClass]="creationStatus.type === 'success' ? 'success' : 'error'">
                      <i class="pi" [ngClass]="creationStatus.type === 'success' ? 'pi-check-circle' : 'pi-exclamation-circle'"></i>
                      <span>{{ creationStatus.message }}</span>
                      <button *ngIf="creationStatus.type === 'success'" 
                              class="view-btn"
                              (click)="selectedPurpose === 'createJob' ? navigateToJobDetails() : navigateToEventDetails()">
                        <i class="pi pi-external-link"></i>
                        <span>View {{ selectedPurpose === 'createJob' ? 'Job' : 'Event' }}</span>
                      </button>
                  </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="message-v2 ai-message edit-message-v2" *ngIf="isEditing">
                <div class="ai-message-wrapper">
                  <img src="assets/copilot.svg" alt="Copilot" class="copilot-logo">
                  <div class="ai-message-bubble edit-form-bubble">
                    <div class="edit-form-chat-container">
                    <div class="edit-header-chat">
                      <h4 class="edit-title-chat">
                        <i class="pi pi-pencil"></i>
                        Edit {{ selectedPurpose === 'createJob' ? 'Job' : 'Event' }} Details
                      </h4>
                      <button class="close-edit-chat-btn" (click)="cancelEdit()">
                        <i class="pi pi-times"></i>
                      </button>
                    </div>
                  
                  <form [formGroup]="editForm" class="edit-form-chat">
                    <ng-container *ngIf="selectedPurpose === 'createEvent'">
                      <div class="form-group-chat">
                        <label class="form-label-chat">Event Name <span class="required">*</span></label>
                        <input type="text" pInputText formControlName="eventName" class="form-input-chat" placeholder="Enter event name">
                        <app-handle-error [control]="editForm.get('eventName')" name="Event Name" [clicked]="editForm.get('eventName')?.touched || false"></app-handle-error>
                      </div>
                      
                      <div class="form-group-chat neo-input-wrapper">
                        <label class="form-label-chat">Start Date <span class="required">*</span></label>
                        <p-datepicker appendTo="body" [panelStyleClass]="'filter-date-range'" bigger iconDisplay="input" formControlName="startDate" class="form-calendar-chat" [showIcon]="true" dateFormat="mm/dd/yy" [showTime]="true"></p-datepicker>
                        <app-handle-error [control]="editForm.get('startDate')" name="Start Date" [clicked]="editForm.get('startDate')?.touched || false"></app-handle-error>
                      </div>

                      <div class="form-group-chat neo-input-wrapper">
                        <label class="form-label-chat">End Date <span class="required">*</span></label>
                        <p-datepicker appendTo="body" [panelStyleClass]="'filter-date-range'" bigger iconDisplay="input" formControlName="endDate" class="form-calendar-chat" [showIcon]="true" dateFormat="mm/dd/yy" [showTime]="true"></p-datepicker>
                      </div>

                      <div class="form-group-chat neo-input-wrapper">
                        <label class="form-label-chat">Registration Start Date <span class="required">*</span></label>
                        <p-datepicker appendTo="body" [panelStyleClass]="'filter-date-range'" bigger iconDisplay="input" formControlName="registrationStartDate" class="form-calendar-chat" [showIcon]="true" dateFormat="mm/dd/yy" [showTime]="true"></p-datepicker>
                      </div>

                      <div class="form-group-chat neo-input-wrapper">
                        <label class="form-label-chat">Registration End Date <span class="required">*</span></label>
                        <p-datepicker appendTo="body" [panelStyleClass]="'filter-date-range'" bigger iconDisplay="input" formControlName="registrationEndDate" class="form-calendar-chat" [showIcon]="true" dateFormat="mm/dd/yy" [showTime]="true"></p-datepicker>
                      </div>

                      <div class="form-row-chat">
                        <div class="form-group-chat neo-input-wrapper">
                          <label class="form-label-chat">Event Category <span class="required">*</span></label>
                          <p-select bigger [options]="eventCategories" formControlName="eventCategory" 
                                      optionLabel="name" optionValue="id" [filter]="true"
                                      placeholder="Select event category" class="form-dropdown-chat" appendTo="body" #eventCategoryEl
                            [panelStyle]="{
                              'min-width': eventCategoryEl.el.nativeElement.offsetWidth + 'px',
                              'max-width': eventCategoryEl.el.nativeElement.offsetWidth + 'px'
                            }"></p-select>
                        </div>
                        <div class="form-group-chat neo-input-wrapper">
                          <label class="form-label-chat">Event Type <span class="required">*</span></label>
                          <p-select bigger [options]="eventTypes" formControlName="eventType" 
                                      optionLabel="name" optionValue="id" [filter]="true"
                                      placeholder="Select event type" class="form-dropdown-chat"
                                      (onChange)="onEventTypeChangeForEdit()" appendTo="body" #eventTypeEl
                            [panelStyle]="{
                              'min-width': eventTypeEl.el.nativeElement.offsetWidth + 'px',
                              'max-width': eventTypeEl.el.nativeElement.offsetWidth + 'px'
                            }"></p-select>
                        </div>
                      </div>

                      <div *ngIf="editForm.value.eventType && getSelectedEventType()?.institution_select_type !== 'not_applicable'">
                        <div class="form-group-chat institution-name-group neo-input-wrapper">
                          <label class="form-label-chat">
                            Institution Name
                            <span class="required" *ngIf="getSelectedEventType()?.institution_select_type !== 'not_applicable'">*</span>
                          </label>
                          <ng-container *ngIf="getSelectedEventType()?.institution_select_type !== 'single'; else singleInstitutionSelect">
                            <p-multiselect style="width: 100%;" bigger [options]="institutions" formControlName="institutionName" optionLabel="name" optionValue="id"
                              [filter]="true" placeholder="Select institutions" class="form-multiselect-chat" display="chip" [showClear]="true"
                              appendTo="body" #institutionNameEl [virtualScroll]="true" [virtualScrollItemSize]="43" [panelStyle]="{
                                'min-width': institutionNameEl.el.nativeElement.offsetWidth + 'px',
                                'max-width': institutionNameEl.el.nativeElement.offsetWidth + 'px'
                            }">
                            <ng-template let-institution pTemplate="item">
                              <div [title]="institution.name">
                                {{ institution.name }}, {{ institution.city }}
                              </div>
                            </ng-template>
                          </p-multiselect>
                          </ng-container>
                          <ng-template #singleInstitutionSelect>
                            <p-select bigger [options]="institutions" formControlName="institutionName"
                                        optionLabel="name" optionValue="id" [filter]="true"
                                        placeholder="Select institution" class="form-dropdown-chat"
                                        [showClear]="true" #institutionNameSelectEl
                                  [virtualScroll]="true" [virtualScrollItemSize]="43" appendTo="body"
                                  [panelStyle]="{
                                      'min-width': institutionNameSelectEl.el.nativeElement.offsetWidth + 'px',
                                      'max-width': institutionNameSelectEl.el.nativeElement.offsetWidth + 'px'
                                  }">
                                <ng-template let-institution pTemplate="item">
                                  <span class="dropdown-item-content" [title]="institution.name">
                                    {{ institution.name }}, {{ institution.city }}
                                  </span>
                                </ng-template>
                            </p-select>
                          </ng-template>
                        </div>
                        <div class="form-group-chat institution-address-group">
                          <label class="form-label-chat">
                            Institution Address
                            <span class="required" *ngIf="getSelectedEventType()?.institution_select_type !== 'not_applicable'">*</span>
                          </label>
                          <input pInputText formControlName="institutionAddress" class="form-input-chat" placeholder="Enter institution address" />
                        </div>
                      </div>

                      <div class="form-row-chat">
                        <div class="form-group-chat neo-input-wrapper">
                          <label class="form-label-chat">Job Roles <span class="required">*</span></label>
                          <p-multiselect bigger [options]="jobRoles" formControlName="jobRoles" 
                                         optionLabel="name" optionValue="id" [filter]="true"
                                         placeholder="Select job roles" class="form-multiselect-chat"
                                         display="chip" appendTo="body" #jobRolesEl
                            [panelStyle]="{
                              'min-width': jobRolesEl.el.nativeElement.offsetWidth + 'px',
                              'max-width': jobRolesEl.el.nativeElement.offsetWidth + 'px'
                            }"></p-multiselect>
                        </div>
                        <div class="form-group-chat neo-input-wrapper">
                          <label class="form-label-chat">Work Experience (Years)</label>
                          <p-inputNumber bigger formControlName="workExperience" class="form-input-number-chat" [min]="0" [max]="50"></p-inputNumber>
                        </div>
                      </div>

                      <div class="form-row-chat neo-input-wrapper">
                        <div class="form-group-chat">
                          <label class="form-label-chat">Min Salary</label>
                          <p-inputNumber bigger formControlName="minSalary" class="form-input-number-chat" [min]="0" mode="currency" currency="INR" locale="en-IN"></p-inputNumber>
                        </div>
                        <div class="form-group-chat neo-input-wrapper">
                          <label class="form-label-chat">Max Salary</label>
                          <p-inputNumber bigger formControlName="maxSalary" class="form-input-number-chat" [min]="0" mode="currency" currency="INR" locale="en-IN"></p-inputNumber>
                        </div>
                      </div>
                    </ng-container>

                    <ng-container *ngIf="selectedPurpose === 'createJob'">
                      <div class="form-group-chat">
                        <label class="form-label-chat">Job Title <span class="required">*</span></label>
                        <input type="text" pInputText formControlName="jobTitle" class="form-input-chat" placeholder="Enter job title">
                        <app-handle-error [control]="editForm.get('jobTitle')" name="Job Title" [clicked]="editForm.get('jobTitle')?.touched || false"></app-handle-error>
                      </div>

                      <div class="form-row-chat neo-input-wrapper">
                        <div class="form-group-chat">
                          <label class="form-label-chat">Role Type <span class="required">*</span></label>
                          <p-select bigger [options]="roleTypes" formControlName="roleType" optionLabel="label" optionValue="value"
                            [filter]="true" placeholder="Select role type" class="form-dropdown-chat" appendTo="body" #roleTypeEl
                            [panelStyle]="{
                              'min-width': roleTypeEl.el.nativeElement.offsetWidth + 'px',
                              'max-width': roleTypeEl.el.nativeElement.offsetWidth + 'px'
                            }"></p-select>
                        </div>
                        <div class="form-group-chat neo-input-wrapper">
                          <label class="form-label-chat">Work Mode <span class="required">*</span></label>
                          <p-select bigger [options]="workModes" formControlName="workMode" 
                                      optionLabel="label" optionValue="value"
                                      placeholder="Select work mode" class="form-dropdown-chat" appendTo="body" #workModeEl
                            [panelStyle]="{
                              'min-width': workModeEl.el.nativeElement.offsetWidth + 'px',
                              'max-width': workModeEl.el.nativeElement.offsetWidth + 'px'
                            }"></p-select>
                        </div>
                      </div>

                      <div class="form-row-chat">
                        <div class="form-group-chat neo-input-wrapper">
                          <label class="form-label-chat">Country <span class="required">*</span></label>
                          <p-select bigger [options]="countries" formControlName="country" optionLabel="label" optionValue="value" [filter]="true"
                            placeholder="Select country" class="form-dropdown-chat" (onChange)="onCountryChangeForEdit($event)" appendTo="body"
                            #countryEl [panelStyle]="{
                                                        'min-width': countryEl.el.nativeElement.offsetWidth + 'px',
                                                        'max-width': countryEl.el.nativeElement.offsetWidth + 'px'
                                                      }"></p-select>
                        </div>
                        <div class="form-group-chat neo-input-wrapper">
                          <label class="form-label-chat">State <span class="required">*</span></label>
                          <p-select bigger [options]="states" formControlName="state" 
                                      optionLabel="label" optionValue="value" [filter]="true"
                                      placeholder="Select state" class="form-dropdown-chat"
                                      (onChange)="onStateChangeForEdit($event)" appendTo="body" #stateEl
                            [panelStyle]="{
                              'min-width': stateEl.el.nativeElement.offsetWidth + 'px',
                              'max-width': stateEl.el.nativeElement.offsetWidth + 'px'
                            }"></p-select>
                        </div>
                      </div>

                      <div class="form-row-chat">
                        <div class="form-group-chat neo-input-wrapper">
                          <label class="form-label-chat">City <span class="required">*</span></label>
                          <p-select bigger [options]="cities" formControlName="city" 
                                      optionLabel="label" optionValue="value" [filter]="true"
                                      placeholder="Select city" class="form-dropdown-chat" appendTo="body" #cityEl
                            [panelStyle]="{
                              'min-width': cityEl.el.nativeElement.offsetWidth + 'px',
                              'max-width': cityEl.el.nativeElement.offsetWidth + 'px'
                            }"></p-select>
                        </div>
                        <div class="form-group-chat neo-input-wrapper">
                          <label class="form-label-chat">Business Unit <span class="required">*</span></label>
                          <input bigger type="text" pInputText formControlName="businessUnit" class="form-input-chat" placeholder="Enter business unit">
                        </div>
                      </div>

                      <div class="form-row-chat">
                        <div class="form-group-chat neo-input-wrapper">
                          <label class="form-label-chat">Open Positions</label>
                          <p-inputNumber bigger formControlName="opening" class="form-input-number-chat" [min]="0" [showButtons]="false"></p-inputNumber>
                        </div>
                        <div class="form-group-chat neo-input-wrapper">
                          <label class="form-label-chat">Max Applicants</label>
                          <p-inputNumber bigger formControlName="maxApplicant" class="form-input-number-chat" [min]="0" [showButtons]="false"></p-inputNumber>
                        </div>
                      </div>

                      <div class="form-group-chat">
                        <label class="form-label-chat">Description <span class="required">*</span></label>
                        <textarea pInputTextarea formControlName="description" class="form-textarea-chat" rows="3" placeholder="Enter description"></textarea>
                  </div>
                    </ng-container>

                    <div class="form-actions-chat">
                      <button type="button" class="cancel-edit-chat-btn" (click)="cancelEdit()">Cancel</button>
                      <button type="button" class="save-edit-chat-btn" (click)="saveChanges()" [disabled]="isUpdating || !hasFormChanges() || !editForm.valid">
                        <span *ngIf="!isUpdating">Save Changes</span>
                        <span *ngIf="isUpdating">
                          <i class="pi pi-spin pi-spinner"></i>
                          Updating...
                        </span>
                      </button>
                    </div>
                  </form>
                    </div>
                  </div>
                </div>
                  </div>

              <div class="message-v2 ai-message edit-helper-message" *ngIf="showEditHelper">
                <div class="ai-message-wrapper">
                  <img src="assets/copilot.svg" alt="Copilot" class="copilot-logo">
                  <div class="ai-message-bubble helper-bubble">
                    <div class="edit-helper-content-v2">
                      <i class="pi pi-info-circle"></i>
                      <p>{{ editHelperText }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="chat-input-section">
          <div class="input-container-v2" [class.expanded]="!apiResponse">
            <div class="input-wrapper-v2">
              <textarea class="input-field-v2"
                        [placeholder]="isEditing ? 'Please save or cancel your changes to continue...' : 'Type your request or select one of the features above...'"
                        [(ngModel)]="userInput"
                        (ngModelChange)="onInputChange($event)"
                        (keyup.enter)="submitInput()"
                        (input)="autoResizeTextarea($event)"
                        (paste)="autoResizeTextarea($event)"
                        [disabled]="isLoading || isCreating || isUpdating || isEditing"
                        rows="1"
                        #chatTextarea></textarea>
              <button class="send-button" 
                      [class]="selectedPurpose === 'createJob' ? 'job-send' : 'event-send'"
                      (click)="submitInput()"
                      [disabled]="!userInput.trim() || isLoading || isCreating || isUpdating || isEditing">
                <i class="pi pi-send"></i>
              </button>
            </div>
          </div>
          <p class="disclaimer-v2" [class]="selectedPurpose === 'createJob' ? 'job-disclaimer' : 'event-disclaimer'">
            *Agent Smith can make mistakes. Consider checking important information.
          </p>
        </div>
      </div>

      <div class="summary-sidebar" 
           *ngIf="apiResponse" 
           [style.width.px]="sidebarWidth"
           [style.min-width.px]="sidebarWidth"
           [style.max-width.px]="sidebarWidth">
        
        <div class="resize-handle" 
             (mousedown)="startResize($event)"
             [class.resizing]="isResizing"></div>
        
        <div class="sidebar-header-v2" [class]="selectedPurpose === 'createJob' ? 'job-header' : 'event-header'">
          <div class="header-content-v2">
            <div class="header-left">
              <div class="header-icon-v2" [class]="selectedPurpose === 'createJob' ? 'job-gradient' : 'event-gradient'">
                <i class="pi" [ngClass]="selectedPurpose === 'createJob' ? 'pi-briefcase' : 'pi-calendar'"></i>
              </div>
              <div class="header-info">
                <h3 class="sidebar-title-v2">Summary</h3>
                <p class="sidebar-subtitle">{{ selectedPurpose === 'createJob' ? 'Job Details' : 'Event Details' }}</p>
              </div>
            </div>
            <button class="new-chat-btn-v2" (click)="restartConversation()">
              <i class="pi pi-refresh"></i>
              <span>New Chat</span>
            </button>
          </div>
        </div>

        <div class="sidebar-content-v2">
          <div class="summary-fields-v2" *ngIf="selectedPurpose === 'createEvent'">
            <div class="field-item-v2" 
                 *ngFor="let field of getEventFields(); let i = index">
              <div class="field-content-v2">
                <p class="field-label-v2">{{ field.label }}</p>
                <p class="field-value-v2">{{ field.value }}</p>
              </div>
            </div>
          </div>

          <div class="summary-fields-v2" *ngIf="selectedPurpose === 'createJob'">
            <div class="field-item-v2" 
                 *ngFor="let field of getJobFields(); let i = index">
              <div class="field-content-v2">
                <p class="field-label-v2">{{ field.label }}</p>
                <p class="field-value-v2" [innerHTML]="field.value"></p>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>

  <div class="confirmation-overlay" *ngIf="showRestartConfirmation || showJobCreationConfirmation">
    <div class="confirmation-modal">
      <h3 class="modal-title">
        {{ showJobCreationConfirmation ? 'View Jobs?' : 'Restart Conversation?' }}
      </h3>
      <p class="modal-description">
        {{ showJobCreationConfirmation ? 
          'Would you like to view all jobs now?' : 
          'This will clear the current conversation and start over. Are you sure?' }}
      </p>
      <div class="modal-actions">
        <button class="btn-cancel" 
                (click)="showJobCreationConfirmation ? cancelJobCreationNavigation() : showRestartConfirmation = false">
        {{ showJobCreationConfirmation ? 'Stay Here' : 'Cancel' }}
      </button>
        <button class="btn-confirm" 
                (click)="showJobCreationConfirmation ? confirmJobCreationNavigation() : confirmRestart()">
        {{ showJobCreationConfirmation ? 'View Jobs' : 'Restart' }}
      </button>
      </div>
    </div>
  </div>
</div>